import missingUserImage from '@/assets/no-user.svg?raw'

export default missingUserImage
